export const item = () => ({
    display: 'flex',
    alignItems: 'center',
});

export default () => ({
    padding: '1rem',
    '> button:first-of-type': {
        marginRight: '0.5rem',
    },
});
